import { axios } from "utils";

import { PUBLIC_MEETING_URL as endpoint } from "consts";

type ShareMeetingPayload = {
  clientName: string;
  clientEmail: string;
  date: string;
  time: string;
};

export const shareMeeting = async (data: ShareMeetingPayload): Promise<void> => axios.post(`${endpoint}/share`, data);
